import { render, staticRenderFns } from "./ElectronicUploadError.vue?vue&type=template&id=01b80654&scoped=true&"
import script from "./ElectronicUploadError.vue?vue&type=script&lang=js&"
export * from "./ElectronicUploadError.vue?vue&type=script&lang=js&"
import style0 from "./ElectronicUploadError.vue?vue&type=style&index=0&id=01b80654&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b80654",
  null
  
)

export default component.exports